import { featureItems } from '@/mocks/homepage';

export default function FeaturesSection() {
  return (
    <section id="features" className="py-14 md:py-20 bg-background-50">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <h2 className="font-heading text-2xl md:text-3xl text-foreground-950 mb-2">喵趣特色</h2>
          <p className="text-sm text-foreground-500">为什么百万读者选择喵趣漫画</p>
        </div>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5">
          {featureItems.map((item, index) => (
            <div
              key={item.id}
              className="bg-background-100 rounded-lg p-5 border border-background-200/80 text-center group hover:border-primary-200 transition-colors cursor-default"
            >
              <span className={`inline-flex items-center justify-center w-12 h-12 rounded-full mb-4 ${
                index === 0 ? 'bg-primary-100 text-primary-600' :
                index === 1 ? 'bg-accent-100 text-accent-600' :
                index === 2 ? 'bg-secondary-100 text-secondary-600' :
                'bg-primary-100/70 text-primary-600'
              }`}>
                <i className={`${item.icon} text-xl`}></i>
              </span>
              <h3 className="font-heading text-base text-foreground-900 mb-2">{item.title}</h3>
              <p className="text-sm text-foreground-500 leading-relaxed">{item.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}